
import * as ipxRuntime$sUr6w5MQJB from '/data/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "imgSetup": {
      "modifiers": {
        "loading": "lazy",
        "alt": "",
        "format": [
          "webp",
          "avif"
        ],
        "height": "",
        "width": ""
      }
    }
  },
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$sUr6w5MQJB, defaults: {} }
}
        